import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setBeneficiarioEditar, setIndexBeneficiairoEditar, setShowFormActiom } from './actions';
import { PaginaCompraStateType } from './reducers';

const usePaginaCompra = () => {
  const state: PaginaCompraStateType = useSelector((state: any) => state.PaginaCompra);
  const dispatch = useDispatch();

  const setShowForm = useCallback(
    (payload: boolean) => {
      dispatch(setShowFormActiom(payload));
    },
    [dispatch],
  );

  const editarBeneficiario = useCallback(
    (beneficiario: any, indexEditar: number) => {
      // console.log('INDEX: ', indexEditar);
      // dispatch(setShowFormActiom(beneficiario !== null && indexEditar !== null));
      dispatch(setBeneficiarioEditar(beneficiario));
      dispatch(setIndexBeneficiairoEditar(indexEditar));
    },
    [dispatch],
  );

  return { ...state, setShowForm, editarBeneficiario };
};

export default usePaginaCompra;
